// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kfpepnvuyiidudhchxae.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtmcGVwbnZ1eWlpZHVkaGNoeGFlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkxMDI1OTYsImV4cCI6MjA4NDY3ODU5Nn0.bZP20YmFdWQZUIglNd6QPqzBzkAQzKQPLTxGWXqQWbM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});